module.exports = __webpack_public_path__ + "assets/title-bg.c10ce755.svg";